<i18n locale="en">
  {
    "reservation-embed-preview-heading": "Make a Reservation",
    "reservation-embed-preview-text": "Your reservation widget will render here",
    "no-provider-id": "No reservation provider ID configured"
  }
</i18n>

<template>
  <PreviewSheet class="reservation-embed-preview">
    <div>
      <div v-if="params.providerId" class="flex-col gap-4">
        <PreviewTypography
          :text="t('reservation-embed-preview-heading')"
          variant="heading4"
        />
        <PreviewTypography
          :text="t('reservation-embed-preview-text')"
          variant="paragraphRegular"
        />
      </div>

      <PreviewTypography
        v-else
        :text="t('no-provider-id')"
        variant="paragraphRegular"
        color="secondary"
      />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

import type { ReservationEmbedSection } from '../../../WebsiteBuilder.types'

const props = defineProps<{
  content: ReservationEmbedSection
}>()

const { t } = useI18n()

const params = computed(() => props.content?.params)
</script>

<style lang="scss" scoped>
.reservation-embed-preview {
  padding: 120px;
}
</style>
